/** The module's identity, shared by every host registration (api, worker, web). */
import type { ModuleManifest } from '@daka/core';

import { ORDERS_MODULE_ID } from './constants';
import { ORDER_MESSAGES } from './messages';

export const ORDERS_MANIFEST: ModuleManifest = {
   id: ORDERS_MODULE_ID,
   titleKey: ORDER_MESSAGES.moduleTitle,
   version: '0.1.0'
};
